import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <>
      {/* JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '韩国漫画网 - 免费韩漫首页',
            description: '免费韩漫与漫画大全的聚合地，提供海量在线漫画资源，专注于推荐好看的韩国漫画',
            url: 'https://www.koreanmanhwa.cn/',
            isPartOf: {
              '@type': 'WebSite',
              name: '韩国漫画网',
              url: 'https://www.koreanmanhwa.cn/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.koreanmanhwa.cn/' },
              ],
            },
          }),
        }}
      />

      {/* Hero Section */}
      <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20Korean%20manhwa%20style%20illustration%20featuring%20multiple%20characters%20from%20different%20genres%20romance%20fantasy%20and%20action%2C%20soft%20warm%20lighting%2C%20elegant%20composition%20with%20flowing%20lines%2C%20pastel%20and%20warm%20tone%20palette%2C%20webtoon%20art%20style%2C%20clean%20aesthetic%2C%20suitable%20for%20website%20hero%20background&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="韩国漫画网 - 免费韩漫聚合平台"
          title="韩国漫画网 - 免费韩漫,漫画大全,在线漫画"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 leading-tight">
            发现好看的<strong className="text-primary-300">韩国漫画</strong>
          </h1>
          <p className="text-sm md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
            免费韩漫与漫画大全的聚合地，海量在线漫画资源每日更新，
            <br className="hidden sm:block" />
            专注于推荐最好看的韩国漫画，您的一站式娱乐门户
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/category/all"
              className="px-8 py-3 bg-primary-500 text-white font-medium text-sm rounded-full hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              立即探索
            </Link>
            <Link
              to="/category/romance"
              className="px-8 py-3 bg-white/20 backdrop-blur-sm text-white font-medium text-sm rounded-full border border-white/30 hover:bg-white/30 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              热门恋爱漫
            </Link>
          </div>
          <div className="flex items-center gap-6 mt-10 text-white/60 text-xs md:text-sm">
            <div className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-book-open-line"></i>
              </span>
              <span>1000+ 漫画资源</span>
            </div>
            <div className="w-px h-4 bg-white/20"></div>
            <div className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-refresh-line"></i>
              </span>
              <span>每日更新</span>
            </div>
            <div className="w-px h-4 bg-white/20"></div>
            <div className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-translate-2"></i>
              </span>
              <span>精校中文</span>
            </div>
          </div>
        </div>
      </section>

      {/* Category Navigation */}
      <section className="py-10 md:py-14 bg-background-50">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap justify-center">
            {[
              { slug: 'all', name: '全部', icon: 'ri-apps-line' },
              { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
              { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
              { slug: 'action', name: '动作', icon: 'ri-sword-line' },
              { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
              { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
              { slug: 'drama', name: '剧情', icon: 'ri-emotion-line' },
              { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
              { slug: 'school', name: '校园', icon: 'ri-building-line' },
              { slug: 'historical', name: '古风', icon: 'ri-book-open-line' },
            ].map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-100 text-foreground-700 text-sm hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap border border-background-200/70"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Hot Recommendations */}
      <section className="py-10 md:py-14 bg-background-100">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="mb-8">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
                  <a href="#hot-recommendations">热门推荐</a>
                </h2>
                <p className="mt-2 text-sm text-foreground-600">精选高分韩漫，口碑之选不容错过</p>
              </div>
              <Link
                to="/category/all"
                className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看全部
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
            {[
              {
                slug: 'wo-de-nan-you-shi-ji-qi-ren',
                title: '我的男友是机器人',
                author: '金智恩',
                coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20romantic%20couple%20with%20a%20futuristic%20robot%20theme%2C%20soft%20pink%20and%20silver%20tones%2C%20elegant%20character%20design%2C%20webtoon%20style%2C%20clean%20background%20with%20subtle%20glow%20effects%2C%20vertical%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait',
                rating: 4.8,
                views: 1520000,
                status: '连载中',
              },
              {
                slug: 'mo-fa-shao-nu-de-qi-yuan',
                title: '魔法少女的奇缘',
                author: '朴秀英',
                coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20magical%20girl%20with%20sparkling%20wand%20and%20flowing%20dress%2C%20fantasy%20elements%2C%20soft%20purple%20and%20gold%20accents%2C%20webtoon%20art%20style%2C%20clean%20simple%20background%2C%20vertical%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
                rating: 4.7,
                views: 1280000,
                status: '连载中',
              },
              {
                slug: 'hei-an-cheng-bao-de-mi-mi',
                title: '黑暗城堡的秘密',
                author: '李俊昊',
                coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20Korean%20manhwa%20cover%20illustration%20of%20a%20mysterious%20castle%20silhouette%20with%20a%20shadowy%20figure%2C%20thriller%20mood%2C%20deep%20red%20and%20black%20tones%2C%20webtoon%20style%2C%20minimal%20background%2C%20vertical%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
                rating: 4.9,
                views: 980000,
                status: '已完结',
              },
              {
                slug: 'xing-kong-xia-de-yue-ding',
                title: '星空下的约定',
                author: '崔美来',
                coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%20illustration%20of%20a%20couple%20under%20a%20starry%20night%20sky%2C%20soft%20warm%20lighting%2C%20gentle%20color%20palette%20with%20pink%20and%20blue%20tones%2C%20webtoon%20art%20style%2C%20clean%20composition%2C%20vertical&width=600&height=800&seq=comic-cover-04&orientation=portrait',
                rating: 4.6,
                views: 2100000,
                status: '已完结',
              },
              {
                slug: 'zui-hou-de-jian-ke',
                title: '最后的剑客',
                author: '郑宇成',
                coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20cover%20illustration%20of%20a%20swordsman%20in%20traditional%20clothing%20with%20flowing%20cape%2C%20action%20pose%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20brown%20tones%2C%20webtoon%20art%20style%2C%20clean%20minimal%20background%2C%20vertical&width=600&height=800&seq=comic-cover-05&orientation=portrait',
                rating: 4.5,
                views: 760000,
                status: '连载中',
              },
              {
                slug: 'gao-xiao-tian-tuan',
                title: '搞笑天团',
                author: '韩美娜',
                coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20bright%20Korean%20manhwa%20cover%20illustration%20of%20quirky%20characters%20in%20a%20comedy%20scene%2C%20vibrant%20colors%2C%20expressive%20faces%2C%20webtoon%20style%2C%20clean%20simple%20background%2C%20vertical%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
                rating: 4.4,
                views: 890000,
                status: '连载中',
              },
            ].map((comic) => (
              <Link
                key={comic.slug}
                to={`/article/${comic.slug}`}
                className="group cursor-pointer block"
              >
                <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-3">
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    title={`${comic.title} - 韩国漫画网`}
                    className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute top-2 left-2">
                    <span className={`px-2 py-0.5 text-xs rounded-full font-medium ${
                      comic.status === '连载中' ? 'bg-primary-500 text-white' : 'bg-secondary-500 text-white'
                    }`}>
                      {comic.status}
                    </span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-3">
                    <div className="flex items-center gap-1 text-white text-xs">
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-star-fill text-yellow-400 text-xs"></i>
                      </span>
                      <span>{comic.rating}</span>
                      <span className="mx-1 opacity-50">·</span>
                      <span>{comic.views >= 10000 ? `${(comic.views / 10000).toFixed(0)}万` : comic.views}次阅读</span>
                    </div>
                  </div>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 leading-tight line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Latest Updates */}
      <section className="py-10 md:py-14 bg-background-50">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="mb-8">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
                  <a href="#latest-updates">最新更新</a>
                </h2>
                <p className="mt-2 text-sm text-foreground-600">每日更新最新韩漫章节，精彩不错过</p>
              </div>
              <Link
                to="/category/all"
                className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                更多新作
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
            {[
              {
                slug: 'chong-sheng-zhi-nu-wang-gui-lai',
                title: '重生之女王归来',
                author: '尹素婉',
                coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20cover%20illustration%20of%20an%20elegant%20confident%20woman%20in%20a%20power%20pose%2C%20dramatic%20lighting%2C%20gold%20and%20burgundy%20tones%2C%20webtoon%20style%2C%20clean%20minimal%20background%2C%20vertical&width=600&height=800&seq=comic-cover-07&orientation=portrait',
                rating: 4.7,
                views: 650000,
                status: '连载中',
                updateInfo: '更新至第45话',
              },
              {
                slug: 'xue-xiao-guai-tan',
                title: '学校怪谈',
                author: '张东民',
                coverImage: 'https://readdy.ai/api/search-image?query=A%20creepy%20Korean%20manhwa%20cover%20illustration%20of%20a%20haunted%20school%20corridor%20with%20eerie%20atmosphere%2C%20dark%20green%20and%20gray%20tones%2C%20ghostly%20figure%2C%20webtoon%20horror%20style%2C%20minimal%20background%2C%20vertical&width=600&height=800&seq=comic-cover-08&orientation=portrait',
                rating: 4.3,
                views: 430000,
                status: '连载中',
                updateInfo: '更新至第38话',
              },
              {
                slug: 'gu-feng-mei-ren-mou',
                title: '古风美人谋',
                author: '安素妍',
                coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20illustration%20of%20a%20traditional%20hanbok-clad%20woman%20in%20ancient%20setting%2C%20elegant%20classical%20style%2C%20soft%20jade%20and%20peach%20tones%2C%20webtoon%20art%2C%20clean%20simple%20background%2C%20vertical&width=600&height=800&seq=comic-cover-09&orientation=portrait',
                rating: 4.8,
                views: 720000,
                status: '连载中',
                updateInfo: '更新至第56话',
              },
              {
                slug: 'tian-cai-you-hua-shi',
                title: '天才油画师',
                author: '徐智敏',
                coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20illustration%20of%20a%20young%20artist%20painting%20with%20passion%2C%20colorful%20art%20studio%20vibes%2C%20warm%20natural%20light%2C%20creative%20atmosphere%2C%20webtoon%20style%2C%20clean%20background%2C%20vertical&width=600&height=800&seq=comic-cover-10&orientation=portrait',
                rating: 4.6,
                views: 540000,
                status: '连载中',
                updateInfo: '更新至第68话',
              },
              {
                slug: 'yi-jie-zhi-wang',
                title: '异界之王',
                author: '金泰亨',
                coverImage: 'https://readdy.ai/api/search-image?query=A%20epic%20Korean%20manhwa%20cover%20illustration%20of%20a%20powerful%20warrior%20in%20fantasy%20armor%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20golden%20and%20deep%20blue%20tones%2C%20webtoon%20art%20style%2C%20clean%20background%2C%20vertical&width=600&height=800&seq=comic-cover-11&orientation=portrait',
                rating: 4.5,
                views: 870000,
                status: '连载中',
                updateInfo: '更新至第92话',
              },
              {
                slug: 'mi-mi-lian-ren',
                title: '秘密恋人',
                author: '刘智雅',
                coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20secretive%20Korean%20manhwa%20cover%20illustration%20of%20a%20couple%20hiding%20their%20relationship%2C%20soft%20blush%20pink%20and%20cream%20tones%2C%20intimate%20atmosphere%2C%20webtoon%20style%2C%20clean%20minimal%20background%2C%20vertical&width=600&height=800&seq=comic-cover-12&orientation=portrait',
                rating: 4.7,
                views: 1130000,
                status: '连载中',
                updateInfo: '更新至第78话',
              },
            ].map((comic) => (
              <Link
                key={comic.slug}
                to={`/article/${comic.slug}`}
                className="group cursor-pointer block"
              >
                <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-3">
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    title={`${comic.title} - 韩国漫画网`}
                    className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute top-2 left-2">
                    <span className="px-2 py-0.5 text-xs rounded-full bg-accent-500 text-white font-medium">
                      NEW
                    </span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-3">
                    <p className="text-white text-xs font-medium">{comic.updateInfo}</p>
                    <div className="flex items-center gap-1 text-white/80 text-xs mt-0.5">
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-star-fill text-yellow-400 text-xs"></i>
                      </span>
                      <span>{comic.rating}</span>
                    </div>
                  </div>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 leading-tight line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-10 md:py-14 bg-background-100">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="text-center mb-8">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              <a href="#faq">常见问题</a>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">关于韩国漫画网的常见疑问解答</p>
          </div>
          <div className="max-w-3xl mx-auto space-y-3">
            <div className="bg-background-50 rounded-lg p-5 border border-background-200/70">
              <h3 className="font-heading text-base text-foreground-900 mb-2">韩国漫画网上的漫画都是免费的吗？</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                是的！韩国漫画网上的所有漫画资源均为免费提供。我们致力于为广大漫画爱好者打造一个无需付费即可畅享海量韩漫的平台，让每一位读者都能随时随地享受精彩的韩国漫画。
              </p>
            </div>
            <div className="bg-background-50 rounded-lg p-5 border border-background-200/70">
              <h3 className="font-heading text-base text-foreground-900 mb-2">网站上的漫画多久更新一次？</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                我们每日更新漫画内容，确保读者能够第一时间看到最新的韩漫章节。热门连载漫画通常保持在每周至少更新一次的频率，部分高热作品可能会更频繁地更新。
              </p>
            </div>
            <div className="bg-background-50 rounded-lg p-5 border border-background-200/70">
              <h3 className="font-heading text-base text-foreground-900 mb-2">网站上的漫画有中文翻译吗？</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                所有漫画均提供高质量的中文翻译。我们的翻译团队严格把控翻译质量，力求在保留原作精髓的同时，为中文读者提供最自然流畅的阅读体验。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-14 md:py-20 bg-background-50 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <img
            src="https://readdy.ai/api/search-image?query=A%20subtle%20Korean%20manhwa%20style%20background%20pattern%20with%20soft%20pastel%20colors%2C%20delicate%20illustration%20elements%2C%20light%20texture%2C%20minimal%20design%2C%20warm%20cream%20and%20pink%20tones&width=1920&height=600&seq=cta-bg&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6 text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            开始你的免费韩漫之旅
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-6 max-w-xl mx-auto">
            海量好看韩国漫画等你来探索，每日更新，全本免费，立即开启你的漫画世界！
          </p>
          <Link
            to="/category/all"
            className="inline-flex px-8 py-3 bg-primary-500 text-white font-medium text-sm rounded-full hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            立即探索全部漫画
          </Link>
        </div>
      </section>
    </>
  );
}